import React, { useState, useRef, useCallback } from "react";

interface TooltipProps {
  text: string;
  children: React.ReactElement;
  position?: "bottom" | "top";
}

export function Tooltip({ text, children, position = "bottom" }: TooltipProps) {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const show = useCallback(() => {
    timerRef.current = setTimeout(() => setVisible(true), 380);
  }, []);

  const hide = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setVisible(false);
  }, []);

  return (
    <span
      style={{ position: "relative", display: "inline-flex", alignItems: "center" }}
      onMouseEnter={show}
      onMouseLeave={hide}
    >
      {children}
      {visible && (
        <span
          role="tooltip"
          style={{
            position: "absolute",
            ...(position === "bottom"
              ? { top: "calc(100% + 10px)" }
              : { bottom: "calc(100% + 10px)" }),
            left: "50%",
            transform: "translateX(-50%)",
            background: "#141414",
            border: "1px solid #2e2416",
            borderRadius: 7,
            padding: "6px 11px",
            color: "#d4b87a",
            fontSize: 11,
            fontWeight: 500,
            whiteSpace: "nowrap",
            zIndex: 9999,
            pointerEvents: "none",
            boxShadow: "0 6px 18px rgba(0,0,0,0.55)",
            letterSpacing: "0.02em",
            animation: "tdTooltipIn 0.12s ease",
          }}
        >
          {text}
        </span>
      )}
      <style>{`
        @keyframes tdTooltipIn {
          from { opacity: 0; transform: translateX(-50%) translateY(4px); }
          to   { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
      `}</style>
    </span>
  );
}
